import React from 'react';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  onlyBold: {
    fontWeight: 'bold',
    fontSize: 15,
    textAlign: 'justify',
    marginVertical: 0,
  },
  text: {
    textAlign: 'justify',
    fontSize: 15,
    marginTop: 0,
  },
}));

function MarkingItem(props) {
  const classes = useStyles();

  return (
    <div style={{ marginBottom: 0 }}>
      <Typography className={classes.onlyBold}>{props.marking}</Typography>
      <Typography className={classes.text}>{props.text}</Typography>
    </div>
  );
}

export default MarkingItem;
